import { render, staticRenderFns } from "./StepGrupoFamiliar3.vue?vue&type=template&id=31b72bac"
import script from "./StepGrupoFamiliar3.vue?vue&type=script&lang=js"
export * from "./StepGrupoFamiliar3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports